<template>
  <b-modal
    id="modalInsertUserFlag"
    centered
    title="Inserir Dados"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <b-tabs v-model="tabIndex" pills justified>
      <!-- Aba 1: Inserir Flag -->
      <b-tab title="Insert User Flags">
        <div class="mb-3 mt-3">
          <label for="user_id" class="form-label">ID do Usuário</label>
          <b-form-input
            id="user_id"
            v-model="formFlag.user_id"
            placeholder="Ex: 278"
            type="number"
            :state="!errorsFlag.user_id"
          />
          <b-form-invalid-feedback v-if="errorsFlag.user_id">
            {{ errorsFlag.user_id }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="flag" class="form-label">Flag</label>
          <b-form-input
            id="flag"
            v-model="formFlag.flag"
            placeholder="Ex: enotas"
            type="text"
            :state="!errorsFlag.flag"
          />
          <b-form-invalid-feedback v-if="errorsFlag.flag">
            {{ errorsFlag.flag }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>

      <!-- Aba 2: Inserir Configuração de Venda -->
      <b-tab title="Insert Users Settings">
        <div class="mb-3 mt-3">
          <label for="sale_user_id" class="form-label">ID do Usuário</label>
          <b-form-input
            id="sale_user_id"
            v-model="formSale.user_id"
            placeholder="Ex: 456"
            type="number"
            :state="!errorsSale.user_id"
          />
          <b-form-invalid-feedback v-if="errorsSale.user_id">
            {{ errorsSale.user_id }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="sale_key" class="form-label">Chave (key)</label>
          <b-form-input
            id="sale_key"
            v-model="formSale.key"
            placeholder="Ex: exemplo_key"
            type="text"
            :state="!errorsSale.key"
          />
          <b-form-invalid-feedback v-if="errorsSale.key">
            {{ errorsSale.key }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="sale_value" class="form-label">Valor</label>
          <b-form-input
            id="sale_value"
            v-model="formSale.value"
            placeholder="Ex: exemplo_valor"
            type="text"
            :state="!errorsSale.value"
          />
          <b-form-invalid-feedback v-if="errorsSale.value">
            {{ errorsSale.value }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="primary" @click="submitData">Enviar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import insertUserFlagService from '@services/resources/OperationsService';

const service = insertUserFlagService.build();

export default {
  name: 'modalInsertUserFlag',
  data() {
    return {
      tabIndex: 0,
      formFlag: {
        user_id: '',
        flag: '',
      },
      formSale: {
        user_id: '',
        key: '',
        value: '',
      },
      errorsFlag: {},
      errorsSale: {},
    };
  },
  methods: {
    validateFlag() {
      this.errorsFlag = {};

      if (!this.formFlag.user_id || isNaN(Number(this.formFlag.user_id))) {
        this.errorsFlag.user_id = 'Informe um ID de usuário válido.';
      }

      if (!this.formFlag.flag.trim()) {
        this.errorsFlag.flag = 'O campo flag é obrigatório.';
      }

      return Object.keys(this.errorsFlag).length === 0;
    },

    validateSale() {
      this.errorsSale = {};

      if (!this.formSale.user_id || isNaN(Number(this.formSale.user_id))) {
        this.errorsSale.user_id = 'Informe um ID de usuário válido.';
      }

      if (!this.formSale.key.trim()) {
        this.errorsSale.key = 'O campo chave é obrigatório.';
      }

      if (!this.formSale.value.trim()) {
        this.errorsSale.value = 'O campo valor é obrigatório.';
      }

      return Object.keys(this.errorsSale).length === 0;
    },

    async submitData() {
      try {
        if (this.tabIndex === 0) {
          if (!this.validateFlag()) return;

          await service.post('insert-user-flag', {
            user_id: Number(this.formFlag.user_id),
            flag: this.formFlag.flag.trim(),
          });

          this.$bvToast.toast('Flag inserida com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          });

        } else {
          if (!this.validateSale()) return;

          await service.post('insert-sale-settings', {
            user_id: Number(this.formSale.user_id),
            key: this.formSale.key.trim(),
            value: this.formSale.value.trim(),
          });

          this.$bvToast.toast('Configuração inserida com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          });
        }

        this.$bvModal.hide('modalInsertUserFlag');
        this.resetForm();
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      let message = 'Erro ao enviar';

      if (
        error &&
        error.response &&
        typeof error.response.data === 'string'
      ) {
        const parsed = JSON.parse(error.response.data);

        if (parsed.errors) {
          message = Object.values(parsed.errors).flat().join('\n');
        } else if (parsed.message) {
          message = parsed.message;
        }
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      this.$bvToast.toast(message, {
        title: 'Erro',
        variant: 'danger',
        solid: true,
      });
    },

    resetForm() {
      this.tabIndex = 0;
      this.formFlag = { user_id: '', flag: '' };
      this.formSale = { user_id: '', key: '', value: '' };
      this.errorsFlag = {};
      this.errorsSale = {};
    },
  },
};
</script>
